import { css } from "@emotion/react";
import { ManagementViewTitle } from "../bits/ManagementViewTitle";
import { useTitle } from "../hooks/useTitle";
import { ArchiveBookshelf } from "../patterns/ArchiveBookshelf";

export const Archive = () => {
  useTitle("Archive | Compass");

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 24px;
        gap: 24px;
      `}
    >
      <ManagementViewTitle text="Archive" />
      <div
        css={({ breakpoints }) => css`
          padding: 0 70px;
          width: 100%;

          @media (max-width: ${breakpoints.values.xl}px) {
            padding: 0;
          }
        `}
      >
        <ArchiveBookshelf />
      </div>
    </div>
  );
};
